import React, { useState, useEffect } from 'react';
import {connect} from "react-redux";

function PartnerCard({data, defaultContactPerson}) {

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    // Use state to track which customer is currently displayed
    const [currentCustomerIndex, setCurrentCustomerIndex] = useState(0);
    // Add multiple customer data objects in an array
    const [customersData, setCustomersData] = useState([]);
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Clean up
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(()=>{
        setCurrentCustomerIndex(0);
    }, [data])

    useEffect(() => {
        if(data && data[0]) {
            setCustomersData(data[0].contactPersons)
        } else {
            setCustomersData([defaultContactPerson])
        }
    }, [defaultContactPerson]);
    const customerData = customersData[currentCustomerIndex];

    // Function to handle navigation dot clicks
    const handleDotClick = (index) => {
        setCurrentCustomerIndex(index);
    };

    const styles = {
        container: {
            minHeight: 350,
            backgroundColor: '#fff',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            padding: '24px',
            marginBottom: '20px',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column'
        },
        header: {
            marginBottom: '24px'
        },
        title: {
            fontSize: '18px',
            fontWeight: '600',
            color: 'rgb(52, 71, 103)',
            margin: '0 0 4px 0',
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif'
        },
        subtitle: {
            fontSize: '15px',
            color: '#777',
            margin: '0',
            fontWeight: '400',
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif'
        },
        infoContainer: {
            backgroundColor: 'rgb(248, 249, 250)',
            borderRadius: '6px',
            padding: '24px',
            paddingBottom: '15px'
        },
        infoHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '22px'
        },
        customerName: {
            fontSize: '15px',
            fontWeight: '600',
            color: 'rgb(52, 71, 103)',
            margin: '0',
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif'
        },
        editButton: {
            backgroundColor: 'transparent',
            border: 'none',
            color: 'rgb(123, 128, 154)',
            cursor: 'pointer',
            fontSize: '13px',
            display: 'flex',
            alignItems: 'center',
            padding: '4px 8px',
            borderRadius: '4px'
        },
        editIcon: {
            marginRight: '4px'
        },
        infoRow: {
            marginBottom: '5px',
            display: 'flex'
        },
        infoLabel: {
            color: 'rgb(123, 128, 154)',
            fontSize: '13px',
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            fontWeight: '300'
        },
        infoValue: {
            color: 'rgb(52, 71, 103)',
            fontSize: '13px',
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            fontWeight: '500',
            marginLeft: 12
        },
        footer: {
            display: 'flex',
            alignItems: 'center',
            color: '#999',
            fontSize: '11px',
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            marginTop: 'auto',
        },
        footerIcon: {
            marginRight: '6px',
            display: 'flex',
            alignItems: 'center'
        },
        separator: {
            borderTop: '0px solid rgba(0, 0, 0, 0.12)',
            borderRight: '0px solid rgba(0, 0, 0, 0.12)',
            borderLeft: '0px solid rgba(0, 0, 0, 0.12)',
            backgroundImage: 'linear-gradient(to right, rgba(23, 23, 23, 0), rgba(23, 23, 23, 0.4), rgba(23, 23, 23, 0))',
            height: '0.1rem',
            backgroundColor: 'transparent',
            marginTop: 'auto',
            marginBottom: '15px',
            borderBottom: 'none',
            opacity: '0.25',
            width: '100%'
        },
        contentWrapper: {
            flex: '1',
            display: 'flex',
            flexDirection: 'column',
        },
        footerWrapper: {
            marginTop: 'auto',
        },
        textSection: {
            flex: '1',
            paddingRight: '16px',
            display: 'inline-block',
            maxWidth: '360px'
        },
        name: {
            fontSize: '16px',
            fontWeight: '600',
            color: '#000',
            marginBottom: '16px'
        },
        label: {
            color: '#999'
        },
        value: {
            fontWeight: '500',
            color: '#333'
        },
        imageContainer: {
            width: '90px',
            height: '130px',
            position: 'relative',
            overflow: 'hidden',
            borderRadius: '50%',
            display: 'inline-block',
            float: 'inline-end'
        },
        image: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
        },
        // New styles for navigation dots
        dotsContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
            marginTop: '-12px'
        },
        dot: {
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            backgroundColor: '#ccc',
            cursor: 'pointer',
            transition: 'background-color 0.3s'
        },
        activeDot: {
            backgroundColor: '#666'
        }
    };
    const getInitials = (name) => {
        if (!name) return '';
        return name
            .split(' ')
            .map(word => word[0])
            .join('')
            .toUpperCase();
    };

    return (
        <div style={styles.container}>
            <div style={styles.contentWrapper}>
                <div style={styles.header}>
                    <h2 style={styles.title}>Partnership in quality</h2>
                </div>

                <div style={styles.infoContainer}>
                    <div style={styles.textSection}>
                        <div style={styles.infoHeader}>
                            <h3 style={styles.customerName}>{customerData && customerData.name}</h3>
                        </div>

                        <div style={styles.infoRow}>
                            <span style={styles.infoLabel}>Company name:</span>
                            <span style={styles.infoValue}>{customerData && customerData.companyName}</span>
                        </div>

                        <div style={styles.infoRow}>
                            <span style={styles.infoLabel}>Company address:</span>
                            <span style={styles.infoValue}>{customerData && customerData.companyAddress}</span>
                        </div>

                        <div style={styles.infoRow}>
                            <span style={styles.infoLabel}>Email address:</span>
                            <span style={styles.infoValue}>{customerData && customerData.email}</span>
                        </div>

                        <div style={styles.infoRow}>
                            <span style={styles.infoLabel}>Telephone number:</span>
                            <span style={styles.infoValue}>{customerData && customerData.telephone}</span>
                        </div>
                    </div>
                    {windowWidth > 1750 && (<div style={styles.imageContainer}>
                        {customerData && customerData.photo ? (
                            <img src={customerData.photo} alt="Profile" style={styles.image} />
                        ) : (
                            <div style={{
                                width: '100%',
                                height: '100%',
                                backgroundColor: '#87CEEB', // Błękitne tło
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '8px',
                                ...styles.image
                            }}>
                                <span style={{
                                    color: 'white',
                                    fontSize: '48px',
                                    fontWeight: 'bold'
                                }}>
                                    {getInitials(customerData?.name)}
                                </span>
                            </div>
                        )}
                    </div>)}
                </div>
            </div>

            <div style={styles.footerWrapper}>
                <div style={styles.separator}></div>
                <div style={styles.footer}>
                    <span style={styles.footerIcon}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M12 6V12L16 14" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </span>
                    Last login {customerData && customerData.lastActive}
                </div>
                {/* Navigation dots */}
                <div style={styles.dotsContainer}>
                    {customersData && customersData.map((_, index) => (
                        <div
                            key={index}
                            style={{
                                ...styles.dot,
                                ...(index === currentCustomerIndex ? styles.activeDot : {})
                            }}
                            onClick={() => handleDotClick(index)}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = ({  clientPanel }) => {
    return {
        data: clientPanel.mainPageReducer.rows,
        defaultContactPerson: clientPanel.mainPageReducer.defaultContactPerson
    }
}

const mapDispatchToProps = (dispatch) => {
    return { dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(PartnerCard);
